import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Views from "./views";
import "./translations/i18n";
import { StyleProvider } from "@ant-design/cssinjs";
import { ConfigProvider } from "antd";
import "bootstrap/dist/css/bootstrap.css";
import nlNL from "antd/lib/locale/nl_NL";
import "./assets/css/globals.css";
import "dayjs/locale/nl";
import * as dayjs from "dayjs";
import { AuthProvider } from "./data/hooks/useAuth";
import ErrorBoundary from "./components/ErrorBoundary";
import { UsersProvider } from "./data/hooks/useUsers";

dayjs.locale("nl");

const AppContent = () => {
  return (
    <StyleProvider>
      <ConfigProvider
        locale={nlNL}
        theme={{
          token: {
            colorPrimary: "#938370",
            // Links in de merkkleur. `colorLink` is in Ant Design een EIGEN
            // seed-token: het erft niet van colorPrimary maar valt terug op
            // colorInfo (#1677ff) — daarom waren links blauw terwijl de knoppen
            // al bruin waren. colorInfo laten we met rust: dat is statuskleur
            // (info-Alert, info-Tag), geen navigatie.
            // Hover/active expliciet, want antd leidt ze anders LICHTER af
            // (#ada9a3, contrast 2,3:1 — leest als disabled). Deze twee tinten
            // komen uit generate("#938370") index 7 en 8.
            colorLink: "#938370",
            colorLinkHover: "#6E5E4E",
            colorLinkActive: "#473B2F",
            // Merkfont, hetzelfde als de webshop. Geladen in public/index.html;
            // de fallbacks zijn de systeemfonts die Ant Design zelf ook gebruikt,
            // zodat het scherm bij een trage/geblokkeerde Google Fonts niet
            // terugvalt op Times.
            fontFamily:
              '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
          },
          components: {
            Button: {
              colorPrimary: "#938370",
              // Ant Design zet standaard een 1px slagschaduw onder elke knop
              // (`0 2px 0 rgba(...)`, zie button/style/token.js). Op een kleine
              // knop in een compacte groep - bijvoorbeeld de opslaan-knop naast
              // het containernummer - leest die als een randje dat er half
              // afvalt. Uit voor alle drie de varianten, zodat knoppen door het
              // hele CMS hetzelfde ogen.
              defaultShadow: "none",
              primaryShadow: "none",
              dangerShadow: "none",
            },
          },
        }}
      >
        <BrowserRouter>
          <Routes>
            <Route path="/*" element={<Views />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </StyleProvider>
  );
};

const App = () => {
  // De `users`-collectie wordt als één geheel geabonneerd in
  // layouts/app-layout; useCmsUsers/useWebshopUsers/useSalesPersons leiden hun
  // lijst daaruit af. Hier stonden twee losse queries op dezelfde collectie —
  // zie data/hooks/useUsers.js waarom dat weg moest.

  return (
    <div className="App">
      <AuthProvider>
        <ErrorBoundary>
          <UsersProvider>
            <AppContent />
          </UsersProvider>
        </ErrorBoundary>
      </AuthProvider>
    </div>
  );
};

export default App;
